var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 39,
    viewBox: "0 0 31 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Profile_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4228 10.6707C25.4228 16.1777 21.0074 20.5933 15.4965 20.5933C9.98759 20.5933 5.57031 16.1777 5.57031 10.6707C5.57031 5.16379 9.98759 0.75 15.4965 0.75C21.0074 0.75 25.4228 5.16379 25.4228 10.6707ZM15.5 38.252C7.36695 38.252 0.5 36.9301 0.5 31.8301C0.5 26.7281 7.41009 25.4531 15.5 25.4531C23.6349 25.4531 30.5 26.775 30.5 31.8751C30.5 36.977 23.5899 38.252 15.5 38.252Z",
    fill: "url(#paint0_linear_115_7245)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_115_7245",
    x1: 2.5,
    y1: 6.00028,
    x2: 28.0006,
    y2: 18.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D87FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D71FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueProfileIcon);
export default __webpack_public_path__ + "static/media/blueProfileIcon.3f80491c5a0ae78f3136730560c72fb9.svg";
export { ForwardRef as ReactComponent };